// src/pages/Main/gallery.js

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card, Container } from "react-bootstrap";
import { GalleryCard, Pill } from "pages/Main/frontCards";
import { GALLERY } from "pages/Main/frontContent";
import { PageHead, SectionTitle } from "pages/Main/frontPage";
import FrontShot from "pages/Main/frontShot";
import Title from "context/title";

const VIEWS = ["Workflow", "Debugger", "Playground"];

const Featured = ({ item }) => (
  <Card as={Link} to={item.path} className="fp-card fp-card-link fp-wide">
    <div className="fp-card-img">
      <FrontShot name="gal_deep_research_playground" zoomable={false} alt={"The Deep Research playground: status, "
        + "conversation, activity, plan and the report's sections side by side."} />
    </div>
    <Card.Body className="fp-card-body">
      <span className="fp-eyebrow">Featured</span>
      <Card.Title as="h2" className="fp-card-title">{item.title}</Card.Title>
      <Card.Text className="fp-card-text">
        Plans a line of enquiry, searches the web, reads what it finds and writes a report section by section, with
        every source attached. The playground shows the plan, the activity and the report as they are written.
      </Card.Text>
      <div className="fp-card-pills">{VIEWS.map((view) => <Pill key={view}>{view}</Pill>)}</div>
      <div className="fp-card-meta"><code className="fp-card-code">{item.path.replace(/^\//, "")}</code></div>
    </Card.Body>
  </Card>
);

export default class Gallery extends Component {
  componentDidMount() {
    Title.set("Gallery");
  }

  render() {
    return (
      <>
        <PageHead
          eyebrow="Gallery"
          title="Workflows you can open, fork and run"
          text={"Every entry is a public workflow. Open one to read its definition, fork it into your own "
            + "organization, or start a session and watch it run in the debugger."} />
        <Container className="fp-page-stack">
          <Featured item={GALLERY[0]} />
          <section>
            <SectionTitle
              eyebrow="All workflows"
              text="Six public workflows across research, collaboration and finance." />
            <div className="fp-grid fp-g3">
              {GALLERY.map((item) => <GalleryCard key={item.key} item={item} />)}
            </div>
          </section>
        </Container>
      </>
    );
  }
}
